const API = {
  blog: "/blog",
  blogCategory: (slug) => `/blog/${slug}`,
  blogPost: (categorySlug, slug) => `/blog/${categorySlug}/${slug}`,
  caseStudies: "/case-studies",
  caseStudiesCard: (categorySlug, caseStudySlug) =>
    `/case-studies/${categorySlug}/${caseStudySlug}`,
  caseStudyCategory: (slug) => `/case-studies/${slug}`,
  events: "/events",
  evPost: (categorySlug, slug) => `/events/${categorySlug}/${slug}`,
  evCategory: (slug) => `/events/${slug}`,
  resources: "/resources",
  resourcesCategory: (slug) => `/resources/${slug}`,
  resourcesPost: (categorySlug, slug) => `/resources/${categorySlug}/${slug}`,
  successFactor: "successfactors-implementation-expert",
  successFactorChild: (slug) => `/successfactors-implementation-expert${slug}`,
  experienceCategory: (slug) => `/user-experience/${slug}`,
  experience: "/user-experience",
  landing: (slug) => `/${slug}`,
};

export default Object.freeze(API);
